// == original colours before name change
// Naming comes from this colour creator site: https://coolors.co

// Main component theming
export const colours = {
	tropicalBlue: '#B5DDF5',
	pictonBlue: '#47AAE5',
	honoluluBlue: '#197AB3',
	lapisLuzuli: '#285E7F',
	prussianBlue: '#143040',
	white: '#ffffff',
	lightCoral: '#e57373',
	RedNCS: '#C6062C',
	folly: '#F9355D',
	persianRed: '#D32F2F',
	seasalt: '#FAFAFB',
	mayaBlue: '#6EC6FF',
	dodgerBlue: '#2196f3',
	greenBlue: '#0069c0',
	warningYellow: '#FFF4E5',
	darkYellow: '#663c00',

	// Content background
	backgroundLight: '#EDF6FB',

	// text for contrast
	textGrey: 'hsla(202, 82%, 9%, 0.65)', // hsla(202, 82%, 9%, 0.65)
	textDark: 'hsl(202, 82%, 6%)', // hsl(202, 82%, 6%)
	borderGrey: '#EAEAEA',
	borderLightGrey: '#D8E4EE',
}
